<template>
    <div v-if="client">
        <!-- site url -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Site url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.siteUrl"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- fast login url -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Fast login url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.fastLoginUrl"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- api key -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Casino API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.apiKey"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- use recaptcha -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Use recaptcha</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.generalSettings.useRecaptcha" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- mbk push operations -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Push balance operations to MBK</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.generalSettings.mbkPushOperations"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- bonus pin expiration period -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Bonus pin expiration period</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.bonusPinExpirationPeriod"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- user next bonus pin activation period -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">User next bonus pin activation period</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.userNextBonusPinActivationPeriod"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- default branch -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Default branch</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.defaultBranch"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- default currency -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Default currency</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.generalSettings.defaultCurrency"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-general',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/general.vue